<template>
  <ul class="relative w-full grid grid-flow-col items-center justify-center my-12">
    <li :class="['page-item items-center justify-center absolute left-0 block stroke-current', disabledPrevious && 'disabled', '']">
      <a
        :class="['page-link px-3.5 py-2 flex rounded-full text-black/95 hover:text-sand-90 transition ease-in-out duration-300', disabledPrevious && 'text-sand-80 pointer-events-none']"
        href="#"
        :tabindex="disabledPrevious ? '-1' : null"
        :aria-disabled="disabledPrevious ? 'true' : null"
        @click.prevent="saveAndSetActive(dsPage !== 1 && dsPagecount !== 0 ? dsPage - 1 : dsPage)"
      >
          <svg-icon name="chevron-left" small class="mt-1 mr-1" /> {{ datasetI18n.previous }}
      </a>
    </li>
    <template v-for="(item, index) in dsPages" :key="index">
      <li :class="['page-item items-center justify-center hidden md:block', item === dsPage && 'active', item === morePages && 'disabled']">
        <a
            v-if="item !== morePages"
            :class="['page-link px-3.5 py-2 rounded-full text-black/95 hover:bg-gray-100 transition ease-in-out duration-300',
                item === dsPage && 'bg-sand-80',
                item === morePages && 'text-sand-80 pointer-events-none']"
            href="#"
            @click.prevent="saveAndSetActive(item)"
        >
          {{ item }}
        </a>
        <span v-else class="page-link">
          {{ item }}
        </span>
      </li>
    </template>
    <li :class="['page-item items-center justify-center absolute right-0 block stroke-current', disabledNext && 'disabled']">
      <a
        :class="['page-link px-3.5 py-2 flex rounded-full text-black/95 hover:text-sand-90 transition ease-in-out duration-300', disabledNext && 'text-sand-80 pointer-events-none']"
        href="#"
        :tabindex="disabledNext ? '-1' : null"
        :aria-disabled="disabledNext ? 'true' : null"
        @click.prevent="saveAndSetActive(dsPage !== dsPagecount && dsPagecount !== 0 ? dsPage + 1 : dsPage)"
      >
        {{ datasetI18n.next }} <svg-icon name="chevron-right" small class="mt-1 ml-1"/>
      </a>
    </li>
  </ul>
</template>

<script>
import {DatasetPager} from "vue-dataset";
import SvgIcon from "@components/SvgIcon.vue";

export default {
    components: {SvgIcon},
    ...DatasetPager,
    mounted() {
        this.restoreSortingFromUrl()
    },
    emits: ["update:page"],
    methods: {
        saveAndSetActive(page) {
            this.saveParameter(page);
            this.setActive(page);
            this.$emit("update:page", page);
        },
        restoreSortingFromUrl() {
            const params = new URLSearchParams(window.location.search)
            if (params.has("p")) {
                const p = params.get("p")
                this.setActive(parseInt(p))
            }
        },
        saveParameter(page) {
            const params = new URLSearchParams(window.location.search)
            params.delete("p")
            params.append("p", page)
            window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`)
        },
    }
}
</script>
